<template>
	<mobile v-if="mobile" :tab="tab"></mobile>
	<pc v-else></pc>
</template>

<script>
	import pc from './project_list_pc.vue'
	import mobile from './project_list_m.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'project_list',
		
		props: {
			tab: String
		},
		
		components: {
			pc,
			mobile
		},
		
		computed: {
			...mapState(['mobile'])
		}
	};
</script>

<style lang="stylus" scoped>
</style>